import React from 'react'
import PropTypes from 'prop-types'
import merge from 'lodash/merge'
import Loading from 'components/Loading'
import Button from 'components/Button'
import { PartnerPlanList, PartnerPlanFilter } from './components'
import constants from 'constants'
import { generateCSV } from 'utils/generateCSV'
import Pagination from 'components/Pagination'
import Heading from 'components/Heading'
// import moment from 'moment'
import { format } from 'date-fns'
import { getCurrentPageData } from 'utils/paging'
import { getEmployeeId } from 'utils/getEmployeeId'
import {
  handleFilterValueFromSession,
  updateFilterSessionObject,
  handleClearFilteredPartnerPlans,
  handleDefaultFilteredData,
  handleChangeFilteredPartnerPlans,
  handlePlanStatusSearchTrigger,
  handlePlanYearTrigger,
  handleTextSearchTrigger,
} from 'utils/partnerPlanFilter'
import PartnerPlanStatusTable from './components/PartnerPlanStatusTable'

const styles = Object.assign(
  {},
  require('./PartnerPlans.scss'),
  require('components/Table/Table.scss'),
  { columns: require('./columns.scss') },
)

class HierarchyPlanReportView extends React.Component {
  static propTypes = {
    currentUser: PropTypes.object,
    handleDownloadSelectedPlan: PropTypes.func.isRequired,
    partnerPlans: PropTypes.object.isRequired,
    planView: PropTypes.string.isRequired,
    reportHeader: PropTypes.string.isRequired,
    reportSuffix: PropTypes.string.isRequired,
    selectedPartner: PropTypes.object,
  }
  static defaultProps = {
    selectedPartner: null,
    currentUser: null,
  }

  constructor(props) {
    super(props)
    this.handleChangeFilteredPartnerPlans = this.handleChangeFilteredPartnerPlans.bind(this)
    this.handleClearFilteredPartnerPlans = this.handleClearFilteredPartnerPlans.bind(this)
    this.state = {
      filteredPartnerPlans: [],
      currentPage: {
        pageNum: 0,
      },
    }
  }

  componentDidMount() {
    updateFilterSessionObject(constants.PARTNERPLAN.SEARCHFILTERSTATE.INITIAL, true, true)
  }

  componentWillUnmount() {
    sessionStorage.removeItem(constants.PARTNERPLAN.SEARCHSESSIONKEY.FILTER)
    updateFilterSessionObject(constants.PARTNERPLAN.SEARCHFILTERSTATE.INITIAL, true, true)
  }

  getPageRecords = (pageIndex) => {
    const { currentPage } = this.state
    const newCurrentPage = merge({}, currentPage, {
      pageNum: pageIndex,
    })

    this.setState({ currentPage: newCurrentPage })
  }

  handleClearFilteredPartnerPlans = () => {
    handleClearFilteredPartnerPlans({
      setState: this.setState.bind(this),
      props: this.props,
    })
  }

  handleChangeFilteredPartnerPlans = (partnerPlans) => {
    handleChangeFilteredPartnerPlans({
      setState: this.setState.bind(this),
      partnerPlans,
    })
  }

  render() {
    const {
      partnerPlans,
      planView,
      handleDownloadSelectedPlan,
    } = this.props

    if (partnerPlans.isFetching) {
      return (<Loading pageLoading />)
    }

    const allFilters = handleFilterValueFromSession()
    console.log('allFilters', allFilters)
    let currentData = (allFilters.isPlanStatusSearch || allFilters.isPlanYearSearch || allFilters.isTextSearch)
      ? this.state.filteredPartnerPlans
      : handleDefaultFilteredData(partnerPlans)

    if (allFilters.isClearFilteredData) {
      currentData = this.props.partnerPlans.partnerPlans
    }
    console.log('partnerPlans', this.props.partnerPlans.partnerPlans, 'reportHeader', this.props.reportHeader)
    console.log('currentData', currentData, 'reportHeader', this.props.reportHeader)

    const currentEmployeeId = getEmployeeId(this.props.selectedPartner, this.props.currentUser)
    let planData = []
    if (this.props.reportHeader === constants.PARTNERPLAN.ROLE.BUCOO) {
      planData = currentData.filter(pp => (String(pp.bucooEmpId) === String(currentEmployeeId)))
    } else if (this.props.reportHeader === constants.PARTNERPLAN.ROLE.BL) {
      planData = currentData.filter(pp => (String(pp.blEmpId) === String(currentEmployeeId)))
    } else if (this.props.reportHeader === constants.PARTNERPLAN.ROLE.OPL) {
      planData = currentData.filter(pp => (String(pp.oplEmpId) === String(currentEmployeeId)))
    } else if (this.props.reportHeader === constants.PARTNERPLAN.ROLE.OL) {
      planData = currentData.filter(pp => (String(pp.olEmpId) === String(currentEmployeeId)))
    } else if (this.props.reportHeader === constants.PARTNERPLAN.ROLE.CEO) {
      planData = currentData.filter(pp => (String(pp.ceoEmpId) === String(currentEmployeeId)))
    }

    const paging = getCurrentPageData(this.state.currentPage.pageNum, planData)
    return (
      <div className={styles.content}>
        <Heading noTopPadding>Download plan PDF</Heading>
        <PartnerPlanStatusTable
          data={currentData}
          handleDownloadSelectedPlan={handleDownloadSelectedPlan}
          header={this.props.reportHeader}
        />
        <PartnerPlanFilter
          filteredPartnerPlans={currentData}
          onChangeFilteredPartnerPlans={this.handleChangeFilteredPartnerPlans}
          onClearFilteredPartnerPlans={this.handleClearFilteredPartnerPlans}
          onGetFilterValueFromSession={handleFilterValueFromSession}
          onPlanStatusSearchTrigger={handlePlanStatusSearchTrigger}
          onPlanYearSearchTrigger={handlePlanYearTrigger}
          onTextSearchTrigger={handleTextSearchTrigger}
          partnerPlans={partnerPlans}
        />
        {partnerPlans.fetched && partnerPlans.partnerPlans &&
          <section className={styles.section}>
            <PartnerPlanList
              handleDownloadSelectedPlan={handleDownloadSelectedPlan}
              partnerPlanItems={paging.currentPageData}
              planView={planView}
            />
            { planData.length > 0 ?
              <div>
                <div className={styles.pagination}>
                  <Pagination handleChange={this.getPageRecords} pageCount={paging.pageCount} />
                </div>
                <div className={styles.export}>
                  <Button
                    onClick={() => {
                  generateCSV(constants.PARTNERPLAN.CSVHEADER, planData, `${this.props.reportSuffix}_report_${format(new Date(), constants.DATE_FORMAT.EXPORT_STANDARD)}`)
                  }}
                    type="flat"
                  >
                    EXPORT
                  </Button>
                </div>
              </div>
            : '' }
          </section>
          }
      </div>
    )
  }
}

export default HierarchyPlanReportView



// WEBPACK FOOTER //
// ./src/views/PartnerReports/PartnerPlan/HierarchyPlanReport.js